(() => {
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’'.,&()\-]/g, ' ').replace(/\s+/g, ' ').trim();
  function initialize(root) {
    if (root.dataset.enhanced) return;
    root.dataset.enhanced = 'true';
    const countries = JSON.parse(root.querySelector('[data-import-catalogue]').textContent);
    const byCode = new Map(countries.map(country => [country.code, country]));
    const search = root.querySelector('[data-import-search]');
    const count = root.querySelector('[data-import-count]');
    const empty = root.querySelector('[data-import-empty]');
    const tabs = [...root.querySelectorAll('button[data-region]')];
    const cards = [...root.querySelectorAll('[data-import-route]')].map(card => {
      const country = byCode.get(card.dataset.code);
      return {card, country, terms:[country.en, country.title, country.zhHant, country.zhHans, country.code, ...country.aliases].map(normalize)};
    });
    let region = 'all';
    function apply() {
      const q = normalize(search.value);
      let visible = 0;
      cards.forEach(({card, country, terms}) => {
        const matches = !q || (/^[a-z]$/.test(q) ? normalize(country.en).startsWith(q) : terms.some(term => term.includes(q)));
        card.hidden = !(matches && (region === 'all' || card.dataset.region === region));
        if (!card.hidden) visible++;
      });
      count.textContent = count.dataset.countLabel.replace('__COUNT__', visible);
      empty.hidden = visible !== 0;
    }
    search.addEventListener('input', event => {if (!event.isComposing) apply();});
    search.addEventListener('compositionend', apply);
    tabs.forEach(tab => tab.addEventListener('click', () => {
      region = tab.dataset.region;
      tabs.forEach(button => {
        const active = button === tab;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      apply();
    }));
    apply();
  }
  const initializeAll = () => document.querySelectorAll('[data-hkg-import-directory]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
